import axios from 'axios'

export const apiInstance = axios.create({
  baseURL: 'http://localhost:5001/sangin-clone/us-central1/api'
})
